import { motion } from "framer-motion";
import { BRAND } from "@/data/products";

export default function LogoEmblem() {
  return (
    <section
      data-testid="logo-emblem"
      className="bg-cream-200/50 py-16 md:py-24 relative overflow-hidden"
    >
      {/* subtle radial glow */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(212,169,58,0.10) 0%, transparent 55%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 flex flex-col items-center text-center">
        {/* ornamental line + emblem */}
        <div className="flex items-center gap-6 md:gap-10 mb-8 w-full max-w-3xl">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gold/60 to-gold" />
          <span className="text-gold text-2xl">✦</span>
          <div className="flex-1 h-px bg-gradient-to-l from-transparent via-gold/60 to-gold" />
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          {/* Concentric rings around the logo */}
          <div className="absolute inset-0 rounded-full border border-gold/25 scale-[1.55] pointer-events-none" />
          <div className="absolute inset-0 rounded-full border border-gold/45 scale-[1.32] pointer-events-none" />
          <div className="absolute inset-0 rounded-full border border-gold/70 scale-[1.14] pointer-events-none" />

          <img
            src={BRAND.logo}
            alt="Vardaan Arts Emblem"
            className="relative w-28 h-28 md:w-40 md:h-40 object-contain drop-shadow-[0_4px_20px_rgba(212,169,58,0.25)]"
          />
        </motion.div>

        <div className="flex items-center gap-6 md:gap-10 mt-8 w-full max-w-3xl">
          <div className="flex-1 h-px bg-gradient-to-l from-transparent via-gold/60 to-gold" />
          <span className="text-gold text-2xl">✦</span>
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gold/60 to-gold" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-10"
        >
          <div className="text-[11px] tracking-[0.5em] uppercase text-gold-dark mb-4 font-medium">
            V · A
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.1]">
            <span className="italic gold-text">Vardaan Arts</span>
          </h2>
          <p className="font-serif italic text-xl md:text-2xl text-ink-soft mt-4 tracking-wide">
            Crafting Divine Beauty in Marble
          </p>
          <p className="text-[11px] tracking-[0.4em] uppercase text-ink-soft/70 mt-6 font-medium">
            Est. {BRAND.established} · Thane · India
          </p>
        </motion.div>
      </div>
    </section>
  );
}
